import { render, staticRenderFns } from "./Honored.vue?vue&type=template&id=77706520&scoped=true&"
import script from "./Honored.vue?vue&type=script&lang=js&"
export * from "./Honored.vue?vue&type=script&lang=js&"
import style0 from "./Honored.vue?vue&type=style&index=0&id=77706520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77706520",
  null
  
)

export default component.exports